export default "__VITE_ASSET__DR5D5hwK__"